import React, { useState } from 'react';
import c from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './TipForm.css';
import { InputField, ClickElement } from '../form';
import { submitTipForm } from '../../apis/dumpert';
import { TIPFORM } from '../../lib/labels';

export const TipForm = () => {

  const [email, setEmail] = useState('');
  const [link, setLink] = useState('');
  const [extra, setExtra] = useState('');
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  
  const submit = e => {
    e.preventDefault();
    setLoading(true);
    setFormState({});

    submitTipForm({
      user_email: email,
      article_link: link,
      extra: extra,
    })
      .then(() => {
        setEmail('');
        setLink('');
        setExtra('');
        setLoading(false);
        setFormState({ state: 'success', message: TIPFORM.SUCCESS });
      })
      .catch(() => {
        setLoading(false);
        setFormState({ state: 'error', message: TIPFORM.ERROR });
      });
  };

  const buttonText = !loading ? TIPFORM.SEND : <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />;

  return (
    <div className={styles.linktip}>
      <div className={c('slideheader', styles.title)}>
        <h2>{TIPFORM.TITLE}</h2>
      </div>
      {formState.state === 'success' && <div className={c(styles.message, styles.success)}>
        <div>{formState.message}</div>
        <div className={styles.close} onClick={() => setFormState({})} >
          <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
        </div>
      </div>}
      {formState.state === 'error' && <div className={c(styles.message, styles.error)}>{formState.message}</div>}
      <form onSubmit={submit}>     
        <InputField
          name="link"
          type="text"
          placeholder={TIPFORM.PLACEHOLDER.LINK}
          autoComplete="off"
          value={link}
          onChange={e => setLink(e.target.value)}
          required
        />
        <InputField
          name="extra"
          type="text"
          placeholder={TIPFORM.PLACEHOLDER.EXTRA}
          autoComplete="off"
          value={extra}
          onChange={e => setExtra(e.target.value)}
        />  
        <InputField
          name="email"
          type="email"
          placeholder={TIPFORM.PLACEHOLDER.EMAIL}
          autoComplete="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <ClickElement
          ElementType="button"
          type="submit"
          text={buttonText}
          primary
        />
      </form>     
    </div>
  );
};